import { render, staticRenderFns } from "./PolicyModal.vue?vue&type=template&id=6ada7ab5&"
import script from "./PolicyModal.vue?vue&type=script&lang=js&"
export * from "./PolicyModal.vue?vue&type=script&lang=js&"
import style0 from "./PolicyModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports